import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Response } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private http: HttpClient) { }

  createSession(): Observable<Response<void>> { 
    return this.http.post<Response<void>>(`${environment.apiEndpoint}/sessions`, {}, {
      withCredentials: true
    } );
  }
}
